module.exports = __webpack_public_path__ + "static/media/04-print-ad.c0f55871.png";